import React from "react";

import styles from './style.module.css'
import Checkbox from "../Checkbox";

const CheckboxList = props => {
  
  const {label, status, onChange, className, name, disabled = false, ...other} = props
  return(
    <label className={`${styles.CheckboxList} ${className ? className : ''}`} {...other}>
      <div className={styles.visualCheckbox}>
        <Checkbox checked={status} name={name} onChange={onChange} disabled={disabled}  />
        <span className={styles.label}>{label}</span>
      </div>
    </label>
  )
}
 
export default CheckboxList 